import { Document, Page, View, StyleSheet, Text, Font } from "@react-pdf/renderer";
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf';
import { useCallback, useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import MasterService from "../../../services/master/MasterService";
import { formatDateStringLocalDate } from "../../../utilities/Utils";
import DraftAppendix from "../draft/DraftAppendix";
import Kemasan from "../../../utilities/Kemasan";
import GetDokumen from "../../../utilities/GetDokumen";
import KotaKab from "../../../utilities/KotaKab";
import PropinsiEn from "../../../utilities/PropinsiEn";
import GetDokumenTanggal from "../../../utilities/GetDokumenTanggal";

Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 210,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingEn: {
        fontSize: 8,
        textAlign: "center",
        textDecoration: "underline"
    },
    headingIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
        marginBottom: 3
    },
    textRefNo: {
        fontSize: 7,
        textAlign: "right",
        marginRight: 75
    },
    textBox: {
        fontSize: 7
    },
    textBoxItalic: {
        fontSize: 7,
        fontFamily: "Roboto-Italic"
    },
    table: {
        border: '1 solid black',
        display: 'table',
        width: 'auto',
    },
    tableRow1: {
        border: '1 solid black',
        flexDirection: 'row',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableRowSign: {
        flexDirection: 'row',
        marginTop: 10
    },
    tableRowSignName: {
        flexDirection: 'row',
        marginTop: 40
    },
    tableCol1: {
        width: '30%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol2: {
        width: '5%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol3: {
        width: '60%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol4: {
        width: '30%',
        padding: 5,
        textAlign: 'left',
    },
    tableColTX1: {
        width: '25%',
        padding: 3,
        textAlign: 'left',
    },
    tableColTX2: {
        width: '20%',
        padding: 3,
        textAlign: 'left',
    },
    tableColTX3: {
        width: '40%',
        padding: 3,
        textAlign: 'left',
    },
    tableBox: {
        width: 'auto',
        display: 'table'
    },
    textEn: {
        fontSize: 7,
        textAlign: "left",
        textDecoration: "underline"
    },
    textEnNoUnderline: {
        fontSize: 7,
        textAlign: "left",
    },
    textIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 7,
        textAlign: "left",
    },
    textEnCenter: {
        fontSize: 8,
        textAlign: "center",
        textDecoration: "underline"
    },
    textInCenter: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
    },
    tableColBox1: {
        width: '45%',
        padding: 3,
        textAlign: 'left',
    },
    tableColBox2: {
        width: '5%',
        padding: 3,
        textAlign: 'left',
    },
    tableColBox3: {
        width: '50%',
        padding: 3,
        textAlign: 'left',
    },
    tableColBoxAtt: {
        width: '85%',
        textAlign: 'left',
    },
    tableColBoxSign1: {
        width: '10%',
        textAlign: 'left',
    },
    tableColBoxSign2: {
        width: '20%',
        textAlign: 'left',
    },
    tableColBoxSign3: {
        width: '30%',
        textAlign: 'left',
    },
    tableColBoxSign5: {
        width: '50%',
        textAlign: 'center',
    },
    tableboxSign: {
        width: 'auto',
        display: 'table',
        marginTop: 5
    },
    sectionHeader: {
        paddingTop: 0, // tidak ada padding dinamis
        marginBottom: 0
    }
})

const FormF = ({ dataDisposisi, datappm, qrImage }) => {
    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [dataHc, setDataHc] = useState(null)
    const [upt, setUpt] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [pelBongkar, setPelBongkar] = useState(null)
    const [ppmDetil, setPpmDetil] = useState([])
    const [totalJumlah, setTotalJumlah] = useState([])
    const [ppmKontainer, setPpmKontainer] = useState([])
    const [ppmMutu, setPpmMutu] = useState({})
    const [ppmMutuArea, setPpmMutuArea] = useState(null)
    const [ppmMutuProd, setPpmMutuProd] = useState([])
    const [ppmKemasan, setPpmKemasan] = useState([])

    const [hasilVerLap, setHasilVerLap] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }

        try {
            const jsonMutuPK = {
                nomorAju: datappm.nomorAju,
                noProses: dataDisposisi.noTugas
            };

            const jsonPelMuat = {
                jnsPelabuhan: "D",
                kodePelabuhan: datappm.pelabuhanMuat
            };

            const jsonPelBongkar = {
                jnsPelabuhan: "L",
                kodePelabuhan: datappm.pelabuhanBongkar
            };

            // Jalankan request secara paralel
            const [
                resHc,
                resUpt,
                resPelMuat,
                resPelBongkar,
                resDetil,
                resTotal,
                resKemasanAll,
                resKontainer,
                resMutu,
                resMutuProd,
                resHasilVerLap,
                resMutuArea
            ] = await Promise.all([
                transaksiService.getHcMutuById(jsonMutuPK),
                userService.getUptById(datappm.kdUpt),
                masterService.getPelabuhanById(JSON.stringify(jsonPelMuat)),
                masterService.getPelabuhanById(JSON.stringify(jsonPelBongkar)),
                transaksiService.listPpmDetilAll(datappm.nomorAju),
                transaksiService.getTotalJumlahKomoditiPerSatuan(datappm.nomorAju),
                transaksiService.listPpmKemasanAll(datappm.nomorAju),
                transaksiService.listPpmContainerAll(datappm.nomorAju),
                transaksiService.getPpmMutuById(datappm.nomorAju),
                transaksiService.listPpmMutuProdAll(datappm.nomorAju),
                transaksiService.listHasilVerLapangan(0, datappm.nomorAju, 0, 10),
                transaksiService.getPpmMutuAreaById(datappm.nomorAju)
            ]);

            // Update state (batched oleh React)
            setDataHc(resHc.data);
            setUpt(resUpt.data);
            setPelMuat(resPelMuat.data);
            setPelBongkar(resPelBongkar.data);
            setPpmDetil(resDetil.data?.data ?? []);
            setTotalJumlah(resTotal.data?.data ?? []);
            setPpmKemasan(resKemasanAll.data?.data ?? []);
            setPpmKontainer(resKontainer.data?.data ?? []);
            setPpmMutu(resMutu.data);
            setPpmMutuProd(resMutuProd.data?.data ?? []);
            setHasilVerLap(resHasilVerLap.data?.data?.[0] ?? null);
            setPpmMutuArea(resMutuArea.data);

        } catch (error) {
            console.error("Gagal memuat data:", error);
            // Bisa tambahkan state khusus error untuk ditampilkan ke user
            // setErrorMessage("Terjadi kesalahan saat memuat data, silakan coba lagi.");
        }
    }, [datappm, dataDisposisi, transaksiService, masterService, userService]);

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    return (
        <Document>
            <Page size="LEGAL" style={styles.page}>
                <View style={styles.sectionHeader} fixed>
                    <View>
                        <Text style={styles.textRefNo}>Reference No: {dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol1}>
                                <Text style={styles.textBox}>COUNTRY OF DISPATCH</Text>
                            </View>
                            <View style={styles.tableCol2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>THE REPUBLIC OF INDONESIA</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol1}>
                                <Text style={styles.textBox}>COMPETENT AUTHORITY</Text>
                            </View>
                            <View style={styles.tableCol2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol1}>
                                <Text style={styles.textBox}>INSPECTION AGENCY</Text>
                            </View>
                            <View style={styles.tableCol2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{upt !== null ? upt.nmInggris : '-'}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableBox}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColTX1}>
                                <Text style={styles.textEn}>I. PRODUCT IDENTIFICATION</Text>
                            </View>
                            <View style={styles.tableColTX2}>
                                <Text style={styles.textIn}>/ IDENTIFIKASI PRODUK</Text>
                            </View>
                            <View style={styles.tableColTX3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                        </View>
                        <View style={styles.table}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBox1}>
                                    <Text style={styles.textEn}>Product Description</Text>
                                    <Text style={styles.textIn}>Deskripsi Produk</Text>
                                </View>
                                <View style={styles.tableColBox2}>
                                    <Text style={styles.textBox}>:</Text>
                                </View>
                                <View style={styles.tableCol3}>
                                    <Text style={styles.textBox}>{ppmMutu !== null ? ppmMutu.mutuDesk : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBox1}>
                                    <Text style={styles.textEn}>Species</Text>
                                    <Text style={styles.textIn}>Spesies</Text>
                                </View>
                                <View style={styles.tableColBox2}>
                                    <Text style={styles.textBox}>:</Text>
                                </View>
                                <View style={styles.tableCol3}>
                                    <Text style={styles.textBoxItalic}>
                                        {
                                            ppmDetil.length <= 3 ?
                                                (
                                                    ppmDetil.map((detil, index) => {
                                                        return (
                                                            detil.namaLatin + ';'
                                                        )
                                                    })
                                                ) :
                                                (
                                                    'See Appendix'
                                                )
                                        }
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBox1}>
                                    <Text style={styles.textEn}>Type of Processing</Text>
                                    <Text style={styles.textIn}>Jenis Pengolahan</Text>
                                </View>
                                <View style={styles.tableColBox2}>
                                    <Text style={styles.textBox}>:</Text>
                                </View>
                                <View style={styles.tableCol3}>
                                    <Text style={styles.textBox}>{ppmMutu !== null ? ppmMutu.mutuProses : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBox1}>
                                    <Text style={styles.textEn}>Type And Number of Packaging</Text>
                                    <Text style={styles.textIn}>Jenis dan Jumlah Kemasan</Text>
                                </View>
                                <View style={styles.tableColBox2}>
                                    <Text style={styles.textBox}>:</Text>
                                </View>
                                <View style={styles.tableCol3}>
                                    <Text style={styles.textBox}>
                                        {
                                            ppmKemasan !== null && ppmKemasan.map((kms, idx) => {
                                                return (
                                                    <>{kms.jumlah} <Kemasan id={kms.kodeKemasan} />;</>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBox1}>
                                    <Text style={styles.textEn}>Lot Identification Code</Text>
                                    <Text style={styles.textIn}>Kode Produksi</Text>
                                </View>
                                <View style={styles.tableColBox2}>
                                    <Text style={styles.textBox}>:</Text>
                                </View>
                                <View style={styles.tableCol3}>
                                    <Text style={styles.textBox}>
                                        {
                                            ppmMutuProd.map((mutuProd, index) => {
                                                return (
                                                    mutuProd.mutuProdNo + '; '
                                                )
                                            })

                                        }
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBox1}>
                                    <Text style={styles.textEn}>Net Weight</Text>
                                    <Text style={styles.textIn}>Berat Bersih</Text>
                                </View>
                                <View style={styles.tableColBox2}>
                                    <Text style={styles.textBox}>:</Text>
                                </View>
                                <View style={styles.tableCol3}>
                                    <Text style={styles.textBox}>
                                        {/* {dataHc !== null ? dataHc.netto : ''} KGS */}
                                        {
                                            totalJumlah.map((detil, index) => {
                                                return (
                                                    detil.kodeSatuan.toUpperCase() === 'KGM' ?
                                                        detil.totalJumlah + ' ' + detil.kodeSatuan.toUpperCase() :
                                                        detil.totalJumlah + ' ' + detil.kodeSatuan.toUpperCase() + ' = ' + detil.totalNetto + ' KGM'
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableBox}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColTX1}>
                                <Text style={styles.textEn}>II. ORIGIN OF PRODUCT</Text>
                            </View>
                            <View style={styles.tableColTX2}>
                                <Text style={styles.textIn}>/ ASAL PRODUK</Text>
                            </View>
                            <View style={styles.tableColTX3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Name and Address Consignor</Text>
                                <Text style={styles.textIn}>Nama dan Alamat Pengirim</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmPengirim : ''}</Text>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.alPengirim : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Name and Address Establishment</Text>
                                <Text style={styles.textIn}>Nama dan Alamat Unit Pengolahan Ikan</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.alUpi : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Register Number/License</Text>
                                <Text style={styles.textIn}>Nomor Registrasi/Lisensi</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.noRegUpi : ''}</Text>
                            </View>
                        </View>
                        {
                            hasilVerLap && hasilVerLap.stsPrint === '1' &&
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBox1}>
                                    <Text style={styles.textEn}>Farm Name and Location</Text>
                                    <Text style={styles.textIn}>Nama Farm dan Lokasi</Text>
                                </View>
                                <View style={styles.tableColBox2}>
                                    <Text style={styles.textBox}>:</Text>
                                </View>
                                <View style={styles.tableCol3}>
                                    <Text style={styles.textBox}>{ppmMutuArea !== null ? (ppmMutuArea.mutuArea === '1' ? <>{ppmMutuArea.mutuBudidayaNama} <KotaKab id={ppmMutuArea.mutuCultKota} />, <PropinsiEn id={ppmMutuArea.mutuCultProp} /></> : '') : ''}</Text>
                                </View>
                            </View>
                        }
                    </View>
                    <View style={styles.tableBox}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColTX1}>
                                <Text style={styles.textEn}>III. DESTINATION OF PRODUCT</Text>
                            </View>
                            <View style={styles.tableColTX2}>
                                <Text style={styles.textIn}>/ TUJUAN PRODUK</Text>
                            </View>
                            <View style={styles.tableColTX3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Place of Dispatch</Text>
                                <Text style={styles.textIn}>Tempat Pengiriman</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{pelMuat !== null ? pelMuat.uraianPelabuhan : ''}, INDONESIA</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Place of Destination</Text>
                                <Text style={styles.textIn}>Tempat Penerimaan</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{pelBongkar !== null ? pelBongkar.uraianPelabuhan : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Means of Transport</Text>
                                <Text style={styles.textIn}>Cara Transportasi</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol4}>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmTrans : ''} / {dataHc !== null ? dataHc.noFlight : ''}</Text>
                                <Text style={styles.textBox}>
                                    {
                                        ppmKontainer !== undefined && ppmKontainer !== null &&
                                        ppmKontainer.map((kont, index) => {
                                            return (
                                                <>
                                                    {kont.nomor} / {kont.nomorSegel} ;
                                                </>
                                            )
                                        })
                                    }
                                </Text>
                            </View>
                            <View style={styles.tableCol4}>
                                <Text style={styles.textEn}>Bill Of Lading No/</Text>
                                <Text style={styles.textIn}>No Dokumen Muat :</Text>
                                <Text style={styles.textBox}>
                                    {datappm !== null ? (<GetDokumen nomorAju={datappm.nomorAju} idJnsDok={'705'} /> === <></> ? <GetDokumen nomorAju={datappm.nomorAju} idJnsDok={'704'} /> : <GetDokumen nomorAju={datappm.nomorAju} idJnsDok={'705'} />) : ''}
                                </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Temperature Required During Storage and Transportation</Text>
                                <Text style={styles.textIn}>Suhu Selama penyimpanan dan transportasi</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{ppmMutu !== null ? ppmMutu.mutuTemp : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Name and Address of Consigne</Text>
                                <Text style={styles.textIn}>Nama dan Alamat Penerima</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmPenerima : ''}</Text>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.alPenerima : ''}</Text>
                            </View>
                        </View>
                    </View>
                    {
                        hasilVerLap && hasilVerLap.stsPrint === '1' &&
                        <View style={styles.tableBox}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxAtt}>
                                    <Text style={styles.textEnNoUnderline}>IV. Description of CE's Cs-137 testing type(s) : [v] Scanning [v] Product analysis</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxAtt}>
                                    <Text style={styles.textEnNoUnderline}>Result Scanning : The scanned pallet was found to comply with the Cesium-137 free requirements. / Date : <GetDokumenTanggal nomorAju={datappm.nomorAju} idJnsDok={'1018'} /></Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxAtt}>
                                    <Text style={styles.textEnNoUnderline}>Result of Laboratory : The sample have been tested and the results comply with the Cesium-137 free ( &lt;0,80 Bq/kg). / Date : <GetDokumenTanggal nomorAju={datappm.nomorAju} idJnsDok={'1019'} /></Text>
                                </View>
                            </View>
                        </View>
                    }
                    <View style={styles.tableBox}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol2}>
                                {
                                    (hasilVerLap && hasilVerLap.stsPrint === '1') ?
                                        <Text style={styles.textBox}>V.</Text> :
                                        <Text style={styles.textBox}>IV.</Text>
                                }
                            </View>
                            <View style={styles.tableCol1}>
                                <Text style={styles.textEn}>ATTESTATION</Text>
                                <Text style={styles.textIn}>PERNYATAAN</Text>
                            </View>
                            <View style={styles.tableCol2}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>1.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={[styles.textEn, { fontSize: 7 }]}>The products described above originate from (an) approved establishment (s) and</Text>
                                <Text style={[styles.textIn, { fontSize: 7 }]}>Produk yang diuraikan diatas berasal dari unit pengolahan ikan yang sudah diakui dan</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>2.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={[styles.textEn, { fontSize: 7 }]}>The Product have been handled, prepared or processed, identified, stored and transported under a HACCP - Based Integrated Quality Management Programme, consistently implemented in accordance with the US Food and Drug Administration (US-FDA) regulation 21 CFR Part 117-Current Good Manufacturing Practice, Hazard Analysis, and Risk Based Preventive Controls for Human Food; 21 CFR Part 123-Fish and Fishery Product and under supervision of the Competent Authority.</Text>
                                <Text style={[styles.textIn, { fontSize: 7 }]}>Produk telah ditangani, disiapkan, diolah, diidentifikasi, disimpan dan didistribusikan berdasarkan penerapan Program Manajemen Mutu Terpadu berdasarkan HACCP yang telah diterapkan secara konsisten sesuai dengan persyaratan US Food and Drug Administration (US-FDA) regulation 21 CFR Part 117-Current Good Manufacturing Practice, Hazard Analysis, and Risk Based Preventive Controls for Human Food: 21 CFR Part 123-Fish and Fishery Product dan berada dalam pengawasan Otoritas Kompeten.</Text>
                            </View>
                        </View>
                        {
                            hasilVerLap && hasilVerLap.stsPrint === '1' &&
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBox2}>
                                    <Text style={styles.textBox}>3.</Text>
                                </View>
                                <View style={styles.tableColBoxAtt}>
                                    <Text style={styles.textEn}>The products described above have been tested and verified to be free from Cesium-137 contamination according to current US FDA import certification requirements under Section 801(q) of the Federal Food, Drug and Cosmetic Act (21 U.S.C. 381 (q)), for certain products from certain regions in Indonesia.</Text>
                                    <Text style={styles.textIn}>Produk yang disebutkan di atas telah diuji dan diverifikasi bebas dari kontaminasi Cesium-137 sesuai dengan persyaratan sertifikasi impor US FDA yang berlaku saat ini berdasarkan Section 801(q) dari Federal Food, Drug, and Cosmetic Act (21 U.S.C. 381 (q)), untuk produk tertentu dari wilayah tertentu di Indonesia.</Text>
                                </View>
                            </View>
                        }
                    </View>
                    <View style={styles.tableboxSign}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBoxSign3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableColBoxSign2}>
                                <Text style={styles.textEn}>Done</Text>
                                <Text style={styles.textIn}>Dilaksanakan</Text>
                            </View>
                            <View style={styles.tableColBoxSign3}>
                                <Text style={styles.textBox}>{upt !== null ? upt.kota : ''}</Text>
                            </View>
                            <View style={styles.tableColBoxSign1}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableColBoxSign2}>
                                <Text style={styles.textEn}>On</Text>
                                <Text style={styles.textIn}>Pada</Text>
                            </View>
                            <View style={styles.tableColBoxSign3}>
                                <Text style={styles.textBox}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglHc) : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBoxSign3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textBox}>.....................................................................................................</Text>
                            </View>
                        </View>
                        <View style={styles.tableRowSign}>
                            <View style={styles.tableColBoxSign3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableColBoxSign2}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableColBoxSign3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableColBoxSign5}>
                                <Text style={styles.textEnCenter}>Signature of the official inspector</Text>
                                <Text style={styles.textInCenter}>Tanda tangan Inspektur Mutu</Text>
                            </View>
                            <View style={styles.tableColBoxSign2}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableColBoxSign3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                        </View>
                        <View style={styles.tableRowSignName}>
                            <View style={styles.tableColBoxSign3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableColBoxSign2}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableColBoxSign3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableColBoxSign5}>
                                <Text style={[styles.textBox, { width: "100%" }]}>{dataHc !== null ? dataHc.nmPejabat : ''}</Text>
                                {/* <Text style={styles.textEnCenter}>Name in capital letter</Text>
                                <Text style={styles.textInCenter}>Nama (dengan huruf besar)</Text> */}
                            </View>
                            <View style={styles.tableColBoxSign2}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableColBoxSign3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                        </View>
                    </View>
                </View>
            </Page>
            {
                ppmDetil.length > 3 &&
                <>
                    <DraftAppendix ppmdetil={ppmDetil} datahc={dataHc} upt={upt} dataDisposisi={dataDisposisi} qrImage={qrImage} />
                </>
            }
        </Document>
    )
}

export default FormF